// for add item to cart
export const addCart = (product) => {
    return {
        type: "ADDITEM",
        payload: product,
    };
}

// for delet item from cart
export const deletCart = (product) => {
    return {
        type: "DELETITEM",
        payload: product,
    };
}